export const LANGUAGE = "app-manbalar-app"

export const API_PATH = `https://manbalarbackend.manuscript.uz/${
  localStorage.getItem(LANGUAGE) ? localStorage.getItem(LANGUAGE) : "ky"
}/`;